// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".receipt-details__alert[data-v-27bf3374]{transition:all .5s ease;font-size:15px}\n", ""]);
// Exports
module.exports = exports;
